import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { WeekDay } from "../../../../utils/useWeekCalendar";
import { number2WeekHanzi } from "Utils/filter";

interface DayPickerProps {
    days: WeekDay[];
    weekDay: number; // 默认选择周几
    onChange: (weekDay: number) => void;
}

export default function DayPicker({ days, weekDay, onChange }: DayPickerProps) {
    return (
        <div className={style.root}>
            {days.map((item, index) => (
                <div
                    role="button"
                    key={item.date}
                    className={classNames(style.item, {
                        [style.current]: weekDay === index + 1
                    })}
                    onClick={() => onChange(index + 1)}>
                    <span className={style.week}>
                        {number2WeekHanzi(item.day.isoWeekday())}
                    </span>
                    <span className={style.day}>
                        {item.isToday && (
                            <span className={style.today}>今天</span>
                        )}
                        {!item.isToday && item.day.format("D日")}
                    </span>
                </div>
            ))}
        </div>
    );
}
